import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import {
  LayoutDashboard,
  BarChart3,
  Receipt,
  Users,
  Truck,
  Inbox,
  ArrowRightLeft,
  Building2,
  Banknote,
  FileSpreadsheet,
  BookOpen,
  LogOut,
  Settings as SettingsIcon,
  Crown
} from 'lucide-react';

export default function Layout() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/management', icon: BarChart3, label: 'Gestión' },
    { path: '/transactions', icon: Receipt, label: 'Transacciones' },
    { path: '/customers', icon: Users, label: 'Clientes' },
    { path: '/suppliers', icon: Truck, label: 'Proveedores' },
    { path: '/inbox', icon: Inbox, label: 'Bandeja de Entrada' },
    { path: '/reconciliation', icon: ArrowRightLeft, label: 'Conciliación' },
    { path: '/bank-statements', icon: Building2, label: 'Cartola Bancaria' },
    { path: '/reports', icon: FileSpreadsheet, label: 'Reportes' }, // Icon changed
    { path: '/sales', icon: Banknote, label: 'Ventas' }, // Added
    { path: '/purchase-book', icon: Receipt, label: 'Libro Compras' },
    { path: '/chart-of-accounts', icon: BookOpen, label: 'Plan de Cuentas' },
    { path: '/settings', icon: SettingsIcon, label: 'Configuración' },
  ];

  if (user?.is_super_admin) {
    menuItems.push({ path: '/admin', icon: Crown, label: 'Super Admin' });
  }

  return (
    <div className="flex h-screen bg-background">
      <aside className="w-64 border-r bg-background flex flex-col p-4 gap-2">
        <div className="mb-8 px-4">
          <h1 className="text-2xl font-bold text-primary">Mini ERP</h1>
          <p className="text-sm text-muted-foreground">{user?.name}</p>
          <p className="text-xs text-muted-foreground">{user?.role}</p>
        </div>

        <nav className="flex-1 space-y-1">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav - ${item.label.toLowerCase()} `}
                className={`flex items - center gap - 3 px - 4 py - 3 rounded - md transition - all ${isActive
                  ? 'bg-secondary text-secondary-foreground font-semibold'
                  : 'text-muted-foreground hover:text-foreground hover:bg-secondary/50'
                  } `}
              >
                <Icon className="h-5 w-5" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <Button
          variant="ghost"
          onClick={handleLogout}
          data-testid="logout-button"
          className="w-full justify-start gap-3 text-muted-foreground hover:text-foreground"
        >
          <LogOut className="h-5 w-5" />
          <span>Cerrar Sesión</span>
        </Button>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}